module.exports = __webpack_public_path__ + "img/10_19.a83ae618.png";